import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BASE_URL, ENDPOINTS } from '@core/config/constants';
import { ResponseCommonSI } from '@views/interfaces/services/common.interfaces';
import { CostsAndFinancingRequestSI, CostsAndFinancingResponseSI } from '@views/interfaces/services/costs-and-financing.interface';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class CostsAndFinancingService {

  constructor(private _http: HttpClient) { }

  async getCostsAndFinancing(idProject: string): Promise<CostsAndFinancingResponseSI> {
    const result = await firstValueFrom<ResponseCommonSI<CostsAndFinancingResponseSI>>(
      this._http.get(`${BASE_URL}${ENDPOINTS.COSTS_AND_FINANCING}/${idProject}`)
    );
    return result.payload;
  }

  async saveCostsAndFinancing(body: CostsAndFinancingRequestSI): Promise<void> {
    const result = await firstValueFrom<ResponseCommonSI<void>>(
      this._http.post(`${BASE_URL}${ENDPOINTS.COSTS_AND_FINANCING}`, body)
    );
    return result.payload;
  }

}
